import { inject, Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { FeedbackModalComponent } from './feedback-modal/feedback-modal.component';

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  private static readonly STORAGE_KEY = 'phishlab.feedback.surpressAfterCampaign';

  private readonly modalService = inject(NgbModal);

  open(): NgbModalRef {
    const ref = this.modalService.open(FeedbackModalComponent, { backdrop: 'static' });
    ref.result.then(() => {});
    return ref;
  }

  maybeShowAfterCampaign(): void {
    if (this.isSupressed()) return;

    const ref = this.modalService.open(FeedbackModalComponent, { backdrop: 'static' });
    ref.componentInstance.showSuppressOption = true;

    const persistSuppression = () => {
      if (ref.componentInstance.dontShowAgain) this.suppress();
    };
    ref.result.then(persistSuppression, persistSuppression);
  }

  private isSupressed(): boolean {
    try {
      return localStorage.getItem(FeedbackService.STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  }

  private suppress(): void {
    try {
      localStorage.setItem(FeedbackService.STORAGE_KEY, 'true');
    } catch {
      // ignore
    }
  }
}
